<template>
    <div class="bg-sub">
        <div class="header-page">
            <h4 class="text-center header-contact">นโยบายการคุ้มครองข้อมูลส่วนบุคคล</h4>
            <section class="" data-snippet="s_text_block"
                data-name="Text">
                <div class="s_allow_columns container" style="background-color: aliceblue;">
                    <p>
                        &nbsp;<font class="text-black">​</font>
                        <font style="font-size: 14px;color: rgb(51, 85, 119)"></font>
                    </p>
                    <p>
                        <font style="font-size: 14px;color: rgb(51, 85, 119)">&nbsp;&nbsp;&nbsp;&nbsp;<span
                                style="font-size: 16px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></font>
                        <font style="font-size: 14px;" class="text-black"><span
                                style="font-size: 16px;">&nbsp;เว็บไซต์กองทัพอากาศได้จัดทำนโยบายการคุ้มครองข้อมูลส่วนบุคคลฉบับนี้ขึ้น
                                เพื่อคุ้มครองข้อมูลส่วนบุคคลของผู้ใช้บริการทุกท่าน (Personal Information)
                                ที่ติดต่อเข้ามายังเว็บไซต์กองทัพอากาศ ดังนี้</span></font>
                    </p>
                    <p>
                        <font style="font-size: 14px;" class="text-black"><strong style="font-weight: bold"><span
                                    style="font-size: 16px;">การเก็บรวบรวมข้อมูลส่วนบุคคล</span></strong></font>
                    </p>
                    <p>
                        <font style="font-size: 14px;" class="text-black"><span
                                style="font-size: 16px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.
                                เพื่อความสะดวกในการให้บริการแก่ผู้ใช้บริการทุกท่านที่เข้ามาใช้บริการเว็บไซต์กองทัพอากาศ
                                ทางเว็บไซต์จึงได้จัดเก็บรวบรวมข้อมูลส่วนบุคคลของท่านไว้ เช่น อีเมล์แอดเดรส (Email
                                Address) ชื่อ (Name) ที่อยู่หรือที่ทำงาน (Home or Work Address) เขตไปรษณีย์ (ZIP Code)
                                หรือหมายเลข โทรศัพท์ (Telephone Number) เป็นต้น</span><br><span
                                style="font-size: 16px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2.
                                ในกรณีที่ท่านสมัคร (Sign Up) เพื่อสมัครสมาชิกหรือเพื่อใช้บริการอย่างใดอย่างหนึ่ง
                                เว็บไซต์กองทัพอากาศ จะเก็บรวบรวมข้อมูลส่วนบุคคลของท่านเพิ่มเติม ได้แก่ เพศ (Sex) อายุ
                                (Gender) สิ่งที่โปรด ปราน/ความชอบ (Preferences/Favorites) ความสนใจ (Interests)
                                หรือหมายเลขบัตรเครดิต (Credit Card Number) และที่อยู่ในการแจ้งค่าใช้จ่าย (Billing
                                Address)</span><br><span
                                style="font-size: 16px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.
                                นอกจากนั้น เพื่อสำรวจความนิยมในการใช้บริการ
                                อันจะเป็นประโยชน์ในการนำสถิติไปใช้ในการปรับปรุงคุณภาพในการให้บริการของเว็บไซต์กองทัพอากาศ
                                จึงจำเป็นต้องจัดเก็บรวบรวมข้อมูลของท่านบางอย่างเพิ่มเติม ได้แก่ หมายเลขไอพี (IP Address)
                                ชนิดของโปรแกรมค้นผ่าน (Browser Type) โดเมนเนม (Domain Name) บันทึกหน้าเว็บ (Web Page)
                                ของเว็บไซต์ที่ผู้ใช้เยี่ยมชม เวลาที่เยี่ยมชมเว็บไซต์ (Access Times)
                                และเว็บไซต์ที่ผู้ใช้บริการเข้าถึงก่อนหน้านั้น (Re</span>ferring Website
                            Addresses)<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4.
                            เว็บไซต์กองทัพอากาศ ขอแนะนำให้ท่านตรวจสอบนโยบายการคุ้มครองข้อมูลส่วนบุคคล (Privacy Policy)
                            ของเว็บไซต์อื่นที่เชื่อมโยงจากเว็บไซต์นี้
                            เพื่อจะได้ทราบและเข้าใจว่าเว็บไซต์ดังกล่าวเก็บรวบรวม ใช้
                            หรือดำเนินการเกี่ยวกับข้อมูลส่วนบุคคลของท่านอย่างไร ทั้งนี้ เว็บไซต์กองทัพอากาศ
                            ไม่สามารถรับรอง ข้อความหรือรับรองการดำเนินการใด ๆ
                            ตามที่ได้มีการประกาศไว้ในเว็บไซต์ดังกล่าวได้ และไม่ขอรับผิดชอบใด ๆ
                            หากเว็บไซต์เหล่านั้นไม่ได้ปฏิบัติการหรือดำเนินการใด ๆ
                            ตามนโยบายการคุ้มครองข้อมูลส่วนบุคคลที่เว็บไซต์ดังกล่าวได้ประกาศไว้</font>
                    </p>
                    <p>
                        <font style="font-size: 14px;" class="text-black"><strong
                                style="font-weight: bold">การใช้ข้อมูลส่วนบุคคล​</strong></font>
                    </p>
                    <p>
                        <font style="font-size: 14px;" class="text-black">​
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1. เว็บไซต์กองทัพอากาศ
                            จะใช้ข้อมูลส่วนบุคคลของท่านเพียงเท่าที่จำเป็น เช่น ชื่อ และที่อยู่ เพื่อ ใช้ในการติดต่อ
                            ให้บริการ ประชาสัมพันธ์ หรือให้ข้อมูลข่าวสารต่าง ๆ รวมทั้งสำรวจความคิดเห็นของท่านใน
                            กิจการหรือกิจกรรมของเว็บไซต์กองทัพอากาศเท่านั้น<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            2. เว็บไซต์กองทัพอากาศ ขอรับรองว่าจะไม่นำข้อมูลส่วนบุคคลของท่านที่ เว็บไซต์กองทัพอากาศ ได้
                            เก็บรวบรวมไว้ ไปขายหรือเผยแพร่ให้กับบุคคลภายนอกโดยเด็ดขาด
                            เว้นแต่จะได้รับอนุญาตจากท่านเท่านั้น<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.
                            ในกรณีที่เว็บไซต์กองทัพอากาศได้ว่าจ้างหน่วยงานอื่นเพื่อให้ดำเนินการเกี่ยวกับข้อมูลส่วนบุคคล
                            ของท่าน เช่น การจัดส่งพัสดุไปรษณีย์
                            การวิเคราะห์เชิงสถิติในกิจการหรือกิจกรรมของเว็บไซต์กองทัพอากาศ เป็นต้น
                            เว็บไซต์กองทัพอากาศจะกำหนดให้หน่วยงานที่ได้ว่าจ้างให้ดำเนินการดังกล่าว เก็บรักษาความลับ
                            และความปลอดภัยของข้อมูลส่วนบุคคลของท่าน และกำหนดข้อห้ามมิให้มีการนำข้อมูลส่วนบุคคลดังกล่าว
                            ไปใช้นอกเหนือจากกิจกรรม หรือกิจการของเว็บไซต์กองทัพอากาศ</font>
                    </p>
                    <p>
                        <font style="font-size: 14px;" class="text-black"><strong
                                style="font-weight: bold">สิทธิในการควบคุมข้อมูลส่วนบุคคลของท่าน</strong></font>
                    </p>
                    <p>
                        <font style="font-size: 14px;" class="text-black">
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;เพื่อประโยชน์ในการรักษาความเป็นส่วนตัวของท่าน
                            ๆ มีสิทธิเลือกที่จะให้มีการใช้ หรือแชร์ข้อมูลส่วนบุคคลของท่าน หรืออาจเลือกที่จะไม่รับข้อมูล
                            หรือสื่อทางการตลาดใด ๆ จากเว็บไซต์กองทัพอากาศก็ได้
                            เพียงแต่ท่านแจ้งความจำนงดังกล่าวผ่านทางไปรษณีย์อิเล็กทรอนิกส์ (e-Mail)
                            เพื่อให้เว็บไซต์กองทัพอากาศทราบ โดยส่งมาที่ webmaster@rtaf.mi.th</font>
                    </p>
                    <p>
                        <font style="font-size: 14px;" class="text-black"><strong
                                style="font-weight: bold">การรักษาความปลอดภัยสำหรับข้อมูลส่วนบุคคล</strong></font>
                    </p>
                    <p>
                        <font style="font-size: 14px;" class="text-black">
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;เพื่อประโยชน์ในการรักษาความลับและความปลอดภัยสำหรับข้อมูลส่วนบุคคลของท่าน
                            เว็บไซต์กองทัพอากาศจึงได้กำหนดระเบียบภายในหน่วยงาน
                            เพื่อกำหนดสิทธิในการเข้าถึงหรือใช้ข้อมูลส่วนบุคคลของท่าน
                            และเพื่อรักษาความลับและความปลอดภัยของข้อมูลบางอย่างที่มีความสำคัญอย่างยิ่ง เช่น
                            หมายเลขบัตรเครดิต เป็นต้น
                            เว็บไซต์กองทัพอากาศจึงได้จัดให้มีช่องทางการสื่อสารแบบปลอดภัยสำหรับข้อมูลดังกล่าวด้วยการเข้ารหัสลับข้อมูลดังกล่าว
                            เช่น จัดให้มีการใช้ Secure Socket Layer (SSL) Protocol เป็นต้น</font>
                    </p>
                    <p>
                        <font style="font-size: 14px;" class="text-black"><strong style="font-weight: bold">การใช้คุกกี้
                                (Cookies)</strong></font>
                    </p>
                    <p>
                        <font style="font-size: 14px;" class="text-black">
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;“คุกกี้” คือ
                            ข้อมูลที่เว็บไซต์กองทัพอากาศส่งไปยังโปรแกรมค้นผ่านเว็บไซต์ (Web Browser) ของผู้ใช้บริการ
                            และเมื่อมีการติดตั้งข้อมูลดังกล่าวไว้ในระบบของท่านแล้ว หากมีการใช้ “คุกกี้”
                            ก็จะทำให้เว็บไซต์กองทัพอากาศ สามารถบันทึกหรือจดจำข้อมูลของผู้ใช้บริการไว้
                            จนกว่าผู้ใช้บริการจะออกจากโปรแกรมค้นผ่านเว็บไซต์ หรือจนกว่าผู้ใช้บริการจะทำการลบ “คุกกี้”
                            นั้นเสีย หรือไม่อนุญาตให้ “คุกกี้”
                            นั้นทำงานอีกต่อไป<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;หากท่านเลือกใช้
                            “คุกกี้” แล้ว ท่านจะได้รับความสะดวกสบายในการท่องเว็บไซต์มากขึ้น เพราะ “คุกกี้”
                            จะช่วยจดจำเว็บไซต์ที่ท่านแวะหรือเยี่ยมชม ทั้งนี้ เว็บไซต์กองทัพอากาศ จะนำข้อมูลที่ “คุกกี้”
                            ได้บันทึกหรือเก็บรวบรวมไว้ ไปใช้ในการวิเคราะห์เชิงสถิติ
                            หรือในกิจกรรมอื่นของเว็บไซต์กองทัพอากาศ
                            เพื่อปรับปรุงคุณภาพการให้บริการของเว็บไซต์กองทัพอากาศต่อไป</font>
                    </p>
                    <p>
                        <font style="font-size: 14px;" class="text-black"><strong
                                style="font-weight: bold">การปรับปรุงนโยบายการคุ้มครองข้อมูลส่วนบุคคล</strong></font>
                    </p>
                    <p>
                        <font style="font-size: 14px;" class="text-black">
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;เว็บไซต์กองทัพอากาศ
                            อาจทำการปรับปรุงหรือแก้ไขนโยบายการคุ้มครองข้อมูลส่วนบุคคลโดยมิได้ แจ้งให้ท่านทราบล่วงหน้า
                            ทั้งนี้ เพื่อความเหมาะสมและมีประสิทธิภาพในการให้บริการ ดังนั้น เว็บไซต์กองทัพอากาศ
                            จึงขอแนะนำให้ผู้ใช้บริการอ่านนโยบายการคุ้มครองข้อมูลส่วนบุคคลทุกครั้งที่เยี่ยมชม
                            หรือมีการใช้บริการจากเว็บไซต์กองทัพอากาศ</font>
                    </p>
                    <p>
                        <font style="font-size: 14px;" class="text-black"><strong
                                style="font-weight: bold">นโยบายสำหรับเด็ก&nbsp;</strong></font>
                    </p>
                    <p>
                        <font style="font-size: 14px;" class="text-black">
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ได้รับการออกแบบสำหรับผู้ใช้ที่มีอายุตั้งแต่ 13 ปีขึ้นไปเท่านั้น เราไม่ได้เก็บรวบรวมข้อมูลที่สามารถระบุตัวตนได้จากเด็กอายุต่ำกว่า 13 ปี หากท่านรู้ถึงข้อมูลใดๆ ที่เราเก็บรวบรวมมาจากเด็กอายุต่ำกว่า 13 ปี กรุณาติดต่อเราโดยใช้ข้อมูลการติดต่อที่อยู่ด้านล่าง นอกจากนี้ หากเราทราบว่าเราได้เก็บรวบรวมข้อมูลจากเด็กอายุต่ำกว่า 13 ปี เราจะดำเนินการลบข้อมูลดังกล่าวโดยเร็วที่สุด</font>
                    </p>
                    <p>
                        <font style="font-size: 14px;" class="text-black"><strong
                                style="font-weight: bold">การปฏิบัติตามนโยบายคุ้มครองข้อมูลส่วนบุคคลและการติดต่อกับ
                                เว็บไซต์กองทัพอากาศ&nbsp;</strong></font>
                    </p>
                    <p>
                        <font style="font-size: 14px;" class="text-black">
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ในกรณีที่ท่านมีข้อสงสัย
                            ข้อเสนอแนะ หรือข้อติชมใด ๆ เกี่ยวกับนโยบายการคุ้มครองข้อมูลส่วน บุคคล
                            หรือการปฏิบัติตามนโยบายการคุ้มครองข้อมูลส่วนบุคคลฉบับนี้ เว็บไซต์กองทัพอากาศ ยินดีที่จะตอบ
                            ข้อสงสัย รับฟังข้อเสนอแนะ และคำติชมทั้งหลาย
                            อันจะเป็นประโยชน์ต่อการปรับปรุงการให้บริการของเว็บไซต์กองทัพอากาศต่อไป
                            โดยท่านสามารถติดต่อกับเว็บไซต์กองทัพอากาศ ตามที่อยู่ที่ปรากฏข้างล่างนี้</font>
                    </p>
                    <p> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                </div>
            </section>
        </div>
    </div>

</template>

<script>
import config from '../config';
import axios from 'axios';
const Host = config.app.Host;
import {
  mdbRow,
  mdbCol,
  Btn,
  mdbCard,
  mdbCardImage,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbBtn,
  Fa
} from 'mdbvue';

export default {
  name: 'PrivacyPolicy',
  components: {
    mdbRow,
    mdbCol,
    Btn,
    mdbCard,
    mdbCardImage,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbBtn,
    Fa
  },
  mounted() {
    localStorage.pincode = '';
    this.Session();
  },
  methods: {
    Session() {
      let APIgetSession = Host + '/api/v1/member/session';
      axios.post(APIgetSession , {
        token: localStorage.token
      }).then(response => {
        if (response.data.code !== '200') {
          localStorage.emailfront = '';
          localStorage.token = '';
          localStorage.auth = 'false';
        }
      });
    },
  }
};
</script>

<style>
.card-contactus {
  position: absolute;
  top: 35%;
  left: 26%;
  width: 50%;
  margin: 0 auto;
  padding: 50px 0;
}

.bg {
  /*background-position: center;*/
  /*background-size: cover;*/
  height: 400px;
  /*background-image: url("../../src/assets/img/bg-con.jpg");*/
}
</style>
